import { Gauge } from "lucide-react";

export const OdometerNotice = ({ notice }) => {
  if (!notice) return null;

  return (
    <div
      data-testid="odometer-notice-card"
      data-status={notice.status}
      className="rounded-xl border border-warning/40 bg-warning-soft p-5"
    >
      <div className="flex items-start gap-3.5">
        <div
          className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md border-2 border-warning text-warning"
          aria-hidden="true"
        >
          <Gauge className="h-4 w-4" />
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between gap-3">
            <h4 className="font-heading text-sm font-800 uppercase tracking-wide text-warning">
              {notice.title}
            </h4>
            <span
              data-testid="odometer-notice-badge"
              className="rounded-full border border-warning/40 bg-background px-2.5 py-1 font-mono-plex text-[10px] font-600 uppercase tracking-[0.12em] text-warning"
            >
              Verify mileage
            </span>
          </div>
          <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{notice.message}</p>
        </div>
      </div>
    </div>
  );
};
